import React from "react";

const EventOne = () => {
  return (
    <div className="event-area-1 bg-smoke">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="event-wrapp">
              <div className="title-area">
                <span className="sub-title">
                  <img src="assets/img/icon/title_left.svg" alt="shape" />
                  Upcoming Events
                </span>
                <h2 className="sec-title style2">
                  Unlock Business Your Potential
                </h2>
              </div>
              <div className="event-card">
                <div className="icon">
                  <img src="assets/img/icon/event-icon_1-1.svg" alt="img" />
                </div>
                <div className="event-card-details">
                  <h4 className="event-card-title">Best Emplementation</h4>
                  <p className="event-card-text">
                    Ished fact that a reader will be distrol acted bioiiy desig
                    the.ished fact that a reader will distrol acted bioiiy
                  </p>
                </div>
              </div>
              <div className="event-card">
                <div className="icon">
                  <img src="assets/img/icon/event-icon_1-2.svg" alt="img" />
                </div>
                <div className="event-card-details">
                  <h4 className="event-card-title">Design make for you</h4>
                  <p className="event-card-text">
                    Sreader will be distrol acted bioiiy desig the.ished fa that
                    a reader will be distrol acted bioiiy desig the.ished
                  </p>
                </div>
              </div>
              <div className="event-card">
                <div className="icon">
                  <img src="assets/img/icon/event-icon_1-3.svg" alt="img" />
                </div>
                <div className="event-card-details">
                  <h4 className="event-card-title">Finished the process</h4>
                  <p className="event-card-text">
                    Distrol acted bioiiy desig the.ished fact that a reader will
                    distrol acted bioiiy desig the.ished fact that a reader.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="event-image">
              <div className="event-thumb-1">
                <img src="assets/img/normal/event-thumb-1-1.png" alt="img" />
              </div>
              <div className="event-shape">
                <img src="assets/img/normal/event-shape.png" alt="Bizmaster" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventOne;
